import React, { useEffect } from "react";
import { Button } from "components";
import useOnlineStatus from "../../hooks/useOnlineStatus";
import OfflineIcon from "./icon";

import "./style.scss";


const Offline = () => {

    useEffect(() => {
        document.title = `Offline | paylixecommerce`;
    }, []);

    const { checkStatus } = useOnlineStatus();

    return <div className="offline-lists-container">
        <div className="offline-lists-icon">
            <OfflineIcon />
        </div>

        <span className="offline-lists-title">
          You are offline
        </span>

        <span className="offline-lists-subtitle">
            We couldn’t reach our servers, it seems like you’re currently offline. <br/>Please try connecting to a working network and try again.
        </span>

        <div style={{ color: "white" }} onClick={checkStatus}>
            <Button className="offline-lists-button" size="large">
                Retry
            </Button>
        </div>
    </div>
}

export default Offline;
